import audioCtx from './context';
const loadAudioBufferFromFileUrl = async (url) => {
    const audioData = await _loadData(url);
    return await _decodeFileDataToBuffer(audioData);
};
const _loadData = async (url) => {
    const response = await fetch(url);
    return await response.arrayBuffer();
};
const _decodeFileDataToBuffer = async (audioData) => {
    return audioCtx.decodeAudioData(audioData);
};
export default loadAudioBufferFromFileUrl;
